import React, { useEffect, useState } from "react";
import { Grid, MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AdminButton from "components/adminButton";
import Loader from "components/loader/loader";
import { useDispatch, useSelector } from "react-redux";
import AddCouponDialog from "../components/alertDialog/addCouponDialog";
import { getCouponsList } from "store";
import MUIDataTable from "mui-datatables";
import { Menu } from "@mui/material";
import { Tooltip } from "@mui/material";
import moment from "moment/moment";
import { getMomentFormat } from "constants/dateTime.constant";
import TableActionButton from "components/adminTableActionButton";
import { couponDetail } from "store";
import AlertDialog from "components/alertDialog";
import { deleteCoupon } from "store";
export default function Coupons() {
  var page = 1;
  const perPage = 10;
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const { couponList, totalCount, addCouponStatus } = useSelector((state) => state.couponSlice);
  const [showDialog, setShowDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [couponId, setCouponId] = useState();
  const [action, setAction] = useState("");
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [perPageRows, setNumberOfRows] = useState(perPage);
  const [pageCheck, setPageCheck] = useState(1);

  useEffect(() => {
    if (couponList) {
      setIsLoading(false);
    }
  }, [couponList]);
  useEffect(() => {
    fetchCouponsList();
  }, []);
  useEffect(() => {
    if (addCouponStatus) {
      fetchCouponsList();
    }
  }, [addCouponStatus]);
  const fetchCouponsList = (page, numberOfRows) => {
    let data = {
      page: page ? page : 1,
      limit: numberOfRows ? numberOfRows : 10,
      language: i18n?.language
    };
    dispatch(getCouponsList(data, setIsLoading));
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event, dataIndex) => {
    setCouponId(dataIndex);
    setAnchorEl(event.currentTarget);
  };
  const handleEdit = () => {
    setAnchorEl(null);
    dispatch(couponDetail(couponId, i18n?.language));
    setShowDialog(true);
    setAction("Edit");
  };
  const handleDelete = () => {
    setAnchorEl(null);
    setDeleteDialog(true);
  };
  const handleDeleteCoupon = () => {
    dispatch(deleteCoupon(couponId, i18n.language));
    setDeleteDialog(false);
  };
  const optionMenu = () => {
    return (
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <MenuItem onClick={handleEdit}>{t("category.edit")}</MenuItem>
        <MenuItem onClick={handleDelete}>{t("category.delete")}</MenuItem>
      </Menu>
    );
  };
  const options = {
    count: totalCount,
    filter: false,
    pagination: true,
    selectableRows: "none",
    usePaperPlaceholder: false,
    elevation: 0,
    filterType: "dropdown",
    responsive: "vertical",
    print: false,
    download: false,
    viewColumns: false,
    search: false,
    serverSide: true,
    rowsPerPage: perPageRows,
    rowsPerPageOptions: [10, 20, 50, 100],
    textLabels: {
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: t("category.rowsPerPage"),
        displayRows: "of"
      },
      body: {
        noMatch: `Record Not Found`,
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`
      }
    },
    onChangePage(currentPage) {
      if (currentPage >= pageCheck) {
        if (currentPage === 0) {
          currentPage = currentPage + 1;
        }
        setPageCheck(currentPage);
        page = currentPage + 1;
        fetchCouponsList(page, "", "", "");
      } else {
        if (pageCheck > 0) {
          page = pageCheck - 1;
        }
        setPageCheck(page);
        fetchCouponsList(page, "", "", "");
      }
    },
    onChangeRowsPerPage(numberOfRows) {
      setNumberOfRows(numberOfRows);
      fetchCouponsList(page, numberOfRows, "", "");
    }
  };
  const columns = [
    {
      name: "couponCode",
      label: t("coupon.name"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  maxWidth: 140,
                  fontSize: 14
                }}>
                {value.charAt(0).toUpperCase() + value.slice(1)}
              </Typography>
            </Tooltip>
          );
        }
      }
    },
    {
      name: "type",
      label: t("coupon.type"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  maxWidth: 140,
                  fontSize: 14
                }}>
                {value.charAt(0).toUpperCase() + value.slice(1)}
              </Typography>
            </Tooltip>
          );
        }
      }
    },
    {
      name: "percent",
      label: t("coupon.discount"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  maxWidth: 140,
                  fontSize: 14
                }}>
                {value ? `${value}%` : "-"}
              </Typography>
            </Tooltip>
          );
        }
      }
    },
    {
      name: "isExpired",
      label: t("coupon.isExpired"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  maxWidth: 140,
                  fontSize: 14
                }}>
                {value === true ? "Yes" : "No"}
              </Typography>
            </Tooltip>
          );
        }
      }
    },
    {
      name: "expiryDate",
      label: t("coupon.expirydate"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          var localTime = moment.utc(value).toDate();
          return <div style={{ alignItems: "center" }}>{getMomentFormat(localTime)}</div>;
        }
      }
    },
    {
      name: "createdAt",
      label: t("products.createdAt"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          var localTime = moment.utc(value).toDate();
          return <div style={{ alignItems: "center" }}>{getMomentFormat(localTime)}</div>;
        }
      }
    },
    {
      name: "updatedAt",
      label: t("products.updatedAt"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          var localTime = moment.utc(value).toDate();
          return <div style={{ alignItems: "center" }}>{getMomentFormat(localTime)}</div>;
        }
      }
    },
    {
      name: "id",
      label: t("category.action"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (dataIndex) => {
          return (
            <>
              <TableActionButton
                style={{ marginLeft: 10 }}
                onClick={(event) => handleClick(event, dataIndex)}
              />
              {optionMenu()}
            </>
          );
        }
      }
    }
  ];

  return (
    <>
      <AlertDialog
        open={deleteDialog}
        title="Warning"
        text={t("coupon.deleteCoupon")}
        handleClose={setDeleteDialog}
        handleAgree={handleDeleteCoupon}
      />
      <AddCouponDialog
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        action={action}
        couponId={couponId}
      />
      <Grid container>
        <Grid
          container
          sx={{
            border: " 1px solid rgba(224, 224, 224, 1)",
            p: 2,
            backgroundColor: "white"
          }}>
          <Grid container sx={{ justifyContent: "space-between" }}>
            <Grid sx={{ mt: 1 }}>
              <Typography variant="body1" sx={{ fontSize: 18 }} color="secondary.contrastText">
                {t("coupon.title")}
              </Typography>
            </Grid>
            <Grid>
              <AdminButton
                sx={{ mt: "3%" }}
                title={t("coupon.btn")}
                onClick={() => {
                  setAction("Add");
                  setShowDialog(true);
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        {isLoading ? (
          <Grid
            container
            sx={{
              border: "1px solid rgba(224, 224, 224, 1)",
              mt: 2,
              height: 300,
              backgroundColor: "white"
            }}>
            <Grid xs={12} style={{ display: "flex", justifyContent: "center" }}></Grid>
          </Grid>
        ) : (
          <>
            {couponList && couponList.length > 0 ? (
              <Grid container>
                <Grid xs={12}>
                  <MUIDataTable
                    // title={"Events List"}
                    data={couponList}
                    columns={columns}
                    options={options}
                  />
                </Grid>
              </Grid>
            ) : (
              <>
                <Grid
                  container
                  sx={{
                    border: "1px solid rgba(224, 224, 224, 1)",
                    mt: 2,
                    height: 300,
                    backgroundColor: "white"
                  }}>
                  <Grid xs={12} style={{ display: "flex", justifyContent: "center" }}>
                    <Typography sx={{ fontSize: 24, fontWeight: 500, mt: "7.5rem" }}>
                      {t("category.noRecordFound")}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            )}
          </>
        )}

        {isLoading && <Loader open={isLoading} text={t("adrena.pleaseWait")} />}
      </Grid>
    </>
  );
}
